import ProdutoModel from "./ProdutoModel";

export default class CategoriaModel {
  public categoriaId: string = "";
  public nome: string = "";
  public imagem?: string = "";
  public categoriaPaiId: string = "";
  public ativo?: boolean = false;
  public cssClass?: string = "";
  public segundoNivelId?: string = "";
  public terceiroNivelId?: string = "";
  public nivel: number = 1;
  public yourId?: string = "";
  public produtos?: ProdutoModel[] = [];
  public subcategorias?: CategoriaModel[] = [];

  public static toModel(item: any, nivel: number, categoriaId: string = ""): CategoriaModel {
    return {
      categoriaId: (nivel === 1 ? item.ID : (nivel === 2 ? item.IDCategory : (nivel === 3 ? categoriaId : null))),
      nome: item.Description,
      ativo: item.Active as boolean,
      imagem: item.StorageURL,
      cssClass: item.cssClass,
      nivel,
      segundoNivelId: (nivel === 2 ? item.ID : (nivel === 3 ? item.IDSubCategory : null)),
      terceiroNivelId: (nivel === 3 ? item.ID : null),
      yourId: item.YourID,
    } as CategoriaModel;
  }
}
